export class TotemConfiguracion {
  anguloOrientacion: number;
  colorPrimario: string;
  colorSecundario: string;
  descripcion: string;
  direccion: string;
  edificioId: string;
  grupoId: number;
  orientacionId: number;
  tipoId: number;
  id: number;
  imagenEdificio: string;
  logoEdificio: string;
  nodoId: number;
  nombreEdificio: string;
  nombreGrupo: string;
  nombreOrientacion: string;
  nombreTipoTotem: string;
  nombre: string;
  telefonoEdificio: string;

  constructor(item: any) {
    this.anguloOrientacion = Number(item.angulo_orientacion);
    this.colorPrimario     = item.color_primario_edificio;
    this.colorSecundario   = item.color_secundario_edificio;
    this.descripcion       = item.descripcion_tipo_totem;
    this.direccion         = item.direccion_edificio;
    this.edificioId        = item.edificio;
    this.grupoId           = item.id_grupo_totem;
    this.orientacionId     = Number(item.id_orientacion);
    this.tipoId            = item.id_tipo_totem;
    this.id                = item.id_totem;
    this.imagenEdificio    = item.imagen_edificio;
    this.logoEdificio      = item.logo_edificio;
    this.nodoId            = Number(item.nod_id);
    this.nombreEdificio    = item.nombre_edificio;
    this.nombreGrupo       = item.nombre_grupo_totem;
    this.nombreOrientacion = item.nombre_orientacion;
    this.nombreTipoTotem   = item.nombre_tipo_totem;
    this.nombre            = item.nombre_totem;
    this.telefonoEdificio  = item.telefono_edificio;
  }
}
